import { pedidoService, zonaService, tipoEntregaService } from '@/services'

export default {
  namespaced: true,
  state: {
    pedidos: [],
    estado: '',
    filtros: JSON.parse(localStorage.getItem('filtros')) || {
      pedidosHoy: true,
      tamanoPagina: 30,
      tipoEntregaService: [-1],
      tiposPedido: [1, 2, 3, 4, 5],
      zona: -1
    },
    tamanos: [10, 30, 50, 100, 200],
    zonas: [],
    tiposEntrega: []
  },
  getters: {
    sucursal: (state, getters, rootState) => {
      return rootState.sesion.bodega.sucursal
    },
    bodega: (state, getters, rootState) => {
      return rootState.sesion.bodega
    },
    pedidos: (state) => state.pedidos,
    pedidosHoy: (state) => state.filtros.pedidosHoy ?? true,
    tamanoPagina: (state) => state.filtros.tamanoPagina ?? 30,
    tiposEntrega: (state) => state.filtros.tiposEntrega ?? [-1],
    tiposPedido: (state) => state.filtros.tiposPedido ?? [1, 2, 3, 4, 5],
    zona: (state) => state.filtros.zona ?? -1,
    tamanos: (state) => state.tamanos,
    zonas: (state) => state.zonas || [],
    listaTiposEntrega: (state) => state.tiposEntrega,
    estaCargando: (state) => state.estado === 'loading'
  },
  mutations: {
    SET_PAGESIZE: (state, payload) => {
      state.filtros.tamanoPagina = payload
      localStorage.setItem('filtros', JSON.stringify(state.filtros))
    },
    SET_TIPOS_PEDIDO: (state, payload) => {
      state.filtros.tiposPedido = payload
      localStorage.setItem('filtros', JSON.stringify(state.filtros))
    },
    SET_ZONA: (state, payload) => {
      state.filtros.zona = payload
      localStorage.setItem('filtros', JSON.stringify(state.filtros))
    },
    SET_PEDIDOS_HOY: (state, payload) => {
      state.filtros.pedidosHoy = payload
      localStorage.setItem('filtros', JSON.stringify(state.filtros))
    },
    SET_TIPOS_ENTREGA: (state, payload) => {
      state.filtros.tiposEntrega = payload
      localStorage.setItem('filtros', JSON.stringify(state.filtros))
    },
    PEDIDOS_REQUEST: (state) => (state.estado = 'loading'),
    PEDIDOS_SUCCESS: (state, payload) => {
      state.pedidos = payload
      state.estado = 'ok'
    },
    PEDIDO_UPDATE: (state, payload) => {
      const index = state.pedidos.findIndex((x) => x.id === payload.id)
      state.pedidos[index] = Object.assign(state.pedidos[index], payload)
      state.estado = 'ok'
    },
    PEDIDOS_ERROR: (state) => (state.estado = 'error'),
    ZONAS_SUCCESS: (state, payload) => {
      state.zonas = [
        { id: -1, nombre: 'Todas' },
        ...payload.map((z) => {
          return { id: z.id, nombre: z.nombre }
        })
      ]
    },
    TIPOS_ENTREGA_SUCCESS: (state, payload) => {
      state.tiposEntrega = [
        ...payload.map((z) => {
          return { id: z.id, nombre: z.nombre }
        })
      ]
    }
  },
  actions: {
    updateTodos({ commit, getters, dispatch }) {
      if (getters.bodega) {
        const params = {
          bodegaId: getters.bodega.id,
          pedidos: ['Clasificado', 'Asignado', 'EnEjecucion']
        }
        return dispatch('updatePedidos', params).then((pedidos) =>
          commit('PEDIDOS_SUCCESS', pedidos)
        )
      }
    },
    setPageSize({ commit, dispatch }, payload) {
      commit('SET_PAGESIZE', payload)
      return dispatch('updateTodos')
    },
    setTiposPedido({ commit, dispatch }, payload) {
      commit('SET_TIPOS_PEDIDO', payload)
      return dispatch('updateTodos')
    },
    setZona({ commit, dispatch }, payload) {
      commit('SET_ZONA', payload)
      return dispatch('updateTodos')
    },
    setPedidosHoy({ commit, dispatch }, payload) {
      commit('SET_PEDIDOS_HOY', payload)
      return dispatch('updateTodos')
    },
    setTiposEntrega({ commit, dispatch }, payload) {
      commit('SET_TIPOS_ENTREGA', payload)
      return dispatch('updateTodos')
    },
    async getZonas({ getters, commit }) {
      await zonaService
        .getZonasByBodega(getters.bodega.id)
        .then((response) => commit('ZONAS_SUCCESS', response.data))
    },
    async getTiposEntrega({ getters, commit }) {
      await tipoEntregaService
        .getTiposEntregaByBodega(getters.bodega.id)
        .then((response) => commit('TIPOS_ENTREGA_SUCCESS', response.data))
    },
    async updatePedidos({ state, commit }, payload) {
      commit('PEDIDOS_REQUEST')
      return new Promise((resolve, reject) => {
        pedidoService
          .getPedidos(
            payload.bodegaId,
            payload.pedidos,
            state.filtros.tiposPedido,
            state.filtros.zona,
            state.filtros.pedidosHoy,
            state.filtros.tiposEntrega,
            state.filtros.tamanoPagina
          )
          .then((response) => resolve(response.data))
          .catch((error) => {
            commit('PEDIDOS_ERROR')
            reject(error)
          })
      })
    }
  }
}
